import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { TabTypes } from './TabTypes.js';
import TabsImpl from './TabsImpl.js';
import { DSTab } from './DSTab.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import '@elliemae/ds-classnames';
import './TabsPanels.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import 'memoize-one';
import 'react-swipeable-views';
import './PanelContainer.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import './TabBar.js';
import 'lodash';
import '@elliemae/ds-form/RequiredMark';
import 'resize-observer';
import 'styled-components';
import './Carousel.js';
import '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import '@elliemae/ds-icons/ChevronRight';
import '@elliemae/ds-icons/ChevronLeft';
import '@elliemae/ds-button';
import './useResize.js';
import './SubTabBar.js';

/* eslint-disable react/no-unused-prop-types */

var DSTabs = function DSTabs(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      innerRef = _ref.innerRef,
      _ref$animated = _ref.animated,
      animated = _ref$animated === void 0 ? true : _ref$animated,
      _ref$enableMouseEvent = _ref.enableMouseEvents,
      enableMouseEvents = _ref$enableMouseEvent === void 0 ? false : _ref$enableMouseEvent,
      _ref$allowTextSelecti = _ref.allowTextSelection,
      allowTextSelection = _ref$allowTextSelecti === void 0 ? false : _ref$allowTextSelecti,
      _ref$onTabChange = _ref.onTabChange,
      onTabChange = _ref$onTabChange === void 0 ? function () {
    return null;
  } : _ref$onTabChange,
      _ref$tabsListAriaLabe = _ref.tabsListAriaLabel,
      tabsListAriaLabel = _ref$tabsListAriaLabe === void 0 ? 'Tab list' : _ref$tabsListAriaLabe,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? TabTypes.NORMAL : _ref$type,
      _ref$tabBarExtraConte = _ref.tabBarExtraContent,
      tabBarExtraContent = _ref$tabBarExtraConte === void 0 ? undefined : _ref$tabBarExtraConte,
      tabs = _ref.children,
      _ref$onlyRenderActive = _ref.onlyRenderActiveTab,
      onlyRenderActiveTab = _ref$onlyRenderActive === void 0 ? false : _ref$onlyRenderActive,
      activeTab = _ref.activeTab,
      _ref$withCarousel = _ref.withCarousel,
      withCarousel = _ref$withCarousel === void 0 ? false : _ref$withCarousel,
      firstSubtabRef = _ref.firstSubtabRef,
      lastTabRef = _ref.lastTabRef,
      flexibleTabsHeaders = _ref.flexibleTabsHeaders,
      fixedTabsHeaders = _ref.fixedTabsHeaders,
      _ref$isDSMobile = _ref.isDSMobile,
      isDSMobile = _ref$isDSMobile === void 0 ? false : _ref$isDSMobile;
  return /*#__PURE__*/React.createElement(TabsImpl, {
    activeTab: activeTab,
    firstSubtabRef: firstSubtabRef,
    lastTabRef: lastTabRef,
    allowTextSelection: allowTextSelection,
    animated: animated,
    containerProps: containerProps,
    enableMouseEvents: enableMouseEvents,
    innerRef: innerRef,
    onlyRenderActiveTab: onlyRenderActiveTab,
    onTabChange: onTabChange,
    tabBarExtraContent: tabBarExtraContent,
    tabsListAriaLabel: tabsListAriaLabel,
    type: type,
    withCarousel: withCarousel,
    flexibleTabsHeaders: flexibleTabsHeaders,
    fixedTabsHeaders: fixedTabsHeaders,
    isDSMobile: isDSMobile
  }, tabs);
};

var props = {
  /** Whether the tab transition should animate or not */
  animated: PropTypes.bool.description('Whether the tab transition should animate or not'),

  /** Enables tab transition with mouse drag events */
  enableMouseEvents: PropTypes.bool.description('Enables tab transition with mouse drag events'),

  /** Allow text selection when mouse drag events are active */
  allowTextSelection: PropTypes.bool.description('Allow text selection when mouse drag events are active'),

  /** Handler when a user clicks on a different tab */
  onTabChange: PropTypes.func.description('Handler when a user clicks on a different tab'),

  /** Tab type */
  type: PropTypes.oneOf(['normal', 'subtabs']).description('Tab type'),

  /** Extra content next to the tabs pills */
  tabBarExtraContent: PropTypes.element.description('Extra content next to the tabs pills'),

  /** Only renders the active tab in the DOM */
  onlyRenderActiveTab: PropTypes.bool.description('Only renders the active tab in the DOM'),

  /** Mobile only flexible tabs mode */
  flexibleTabsHeaders: PropTypes.bool.description('Mobile only flexible tabs mode'),

  /** Mobile only fixed tabs mode */
  fixedTabsHeaders: PropTypes.bool.description('Mobile only fixed tabs mode'),

  /** Whether or not it's a ds-tab from DSMobile tabs */
  isDSMobile: PropTypes.bool.description("Whether or not it's a ds-tab from DSMobile tabs"),

  /** Activate carousel behavior */
  withCarousel: PropTypes.bool.description('Activate carousel behavior'),

  /** The active tabId */
  activeTab: PropTypes.string.description('The active tabId'),

  /** tabs children */
  children: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.instanceOf([PropTypes.instanceOf(DSTab), PropTypes.array])
  })).isRequired.description('tabs children'),

  /** Aria label for the list */
  tabsListAriaLabel: PropTypes.string.description('Aria label for the list'),

  /** Additional properties for the container */
  containerProps: PropTypes.object.description('Additional properties for the container'),

  /** REF */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]).description('REF'),

  /** internal ref to handle keyboard a11y behavior */
  firstSubtabRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]).description('internal ref to handle keyboard a11y behavior'),

  /** internal ref to handle keyboard a11y behavior */
  lastTabRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]).description('internal ref to handle keyboard a11y behavior')
};
DSTabs.propTypes = props;
var DSTabsWithSchema = describe(DSTabs);
DSTabsWithSchema.propTypes = props;

export default DSTabs;
export { DSTabs, DSTabsWithSchema };
//# sourceMappingURL=DSTabs.js.map
